export const REGULATOR = {
  VFSC: 'VFSC',
  ASIC: 'ASIC',
  CYSEC: 'CYSEC',
  SEY: 'SEY',
};

//Countries are related to ASIC regulator, should be same as back-end value
const ASIC_COUNTRIES = new Set(['Australia']);

//Countries are related to SEY regulator, should be same as back-end value
const SEY_COUNTRIES = new Set(['Ghana', 'Algeria', 'South Africa', 'Zimbabwe', 'Egypt']);

const CYSEC_COUNTRIES = new Set([]);

export const COUNTRIES_REGULATOR_MAPPER = {
  [REGULATOR.SEY]: SEY_COUNTRIES,
  [REGULATOR.ASIC]: ASIC_COUNTRIES,
};

//list allowed/blocked countries to migrate user when registered country is not match the selected country by user
export const RESTRICTED_COUNTRIES = {
  [REGULATOR.ASIC]: {
    WHITELIST: COUNTRIES_REGULATOR_MAPPER[REGULATOR.ASIC],
  },
  [REGULATOR.VFSC]: {
    BLACKLIST: new Set([
      ...COUNTRIES_REGULATOR_MAPPER[REGULATOR.ASIC],
      ...COUNTRIES_REGULATOR_MAPPER[REGULATOR.SEY],
    ]),
  },
  [REGULATOR.SEY]: {
    WHITELIST: COUNTRIES_REGULATOR_MAPPER[REGULATOR.SEY],
  },
  [REGULATOR.CYSEC]: {
    WHITELIST: CYSEC_COUNTRIES,
  },
};
